import { useEffect, useRef, useState } from 'react';
import WaterRipple from './WaterRipple';

export default function VideoBackground() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [videoError, setVideoError] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleError = (e: Event) => {
      console.error('Video error:', e);
      setVideoError(true);
    };

    video.addEventListener('error', handleError);

    return () => {
      video.removeEventListener('error', handleError);
    };
  }, []);

  return (
    <div className="absolute inset-0 -top-20 w-full h-screen" style={{ touchAction: 'none' }}>
      {/* Video background */}
      {!videoError && (
        <div className="absolute inset-0 z-10">
          <iframe
            src="https://www.youtube.com/embed/8MPX86uzVWU?autoplay=1&mute=1&loop=1&playlist=8MPX86uzVWU&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1"
            className="w-full h-full object-cover pointer-events-none"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>
      )}
      
      {/* Gradient overlay */}
      <div className="absolute inset-0 z-20 bg-gradient-to-b from-black/30 via-transparent to-black/40 pointer-events-none" />
      
      {/* Water ripple effect layer - commented out for now */}
      {/* <WaterRipple 
        tintColor={[255, 255, 255]}
        viscosity={10}
        speed={7}
        size={1.5}
        displacement={2}
        lights={6}
        shadows={3}
        blurRipples={true}
      /> */}
    </div>
  );
} 